import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-boxes',
  standalone: false,
  templateUrl: './progress-boxes.component.html'
})
export class ProgressBoxesComponent {
  @Input() total: number = 5;
  @Input() filled: number = 3;
  @Input() filledColor: string = '#4c4cd7';
  @Input() emptyColor: string = '#e0e0ff';
  @Input() isBordered: boolean = true;
  @Input() borderStyle: 'all-rounded' | 'outer-rounded' = 'all-rounded';
  @Input() smallDimensions!: boolean;

  ngOnInit(): void {
    this.borderStyle = this.isBordered ? 'all-rounded' : 'outer-rounded'
  }
  getBoxes(): string[] {
    return Array.from({ length: this.total }, (_, i) =>
      i < this.filled ? this.filledColor : this.emptyColor
    );
  }
}
